window.addEventListener('load', function () {
  // Close modal utility
  function closeModal(modalWrapper) {
    if (!modalWrapper) return;
    const overlay = modalWrapper.querySelector('.modal-overlay');
    const card = modalWrapper.querySelector('.modal-card');
    if (overlay) overlay.classList.remove('modal-open');
    if (card) card.classList.remove('modal-open');
  }

  // Open modal utility (for triggers, not used by your new code, but safe to keep)
  function openModal(modalWrapper) {
    if (!modalWrapper) return;
    const overlay = modalWrapper.querySelector('.modal-overlay');
    const card = modalWrapper.querySelector('.modal-card');
    if (overlay) overlay.classList.add('modal-open');
    if (card) card.classList.add('modal-open');
  }

  // Handle .modal-trigger clicks (legacy, safe to keep)
  document.querySelectorAll('.modal-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const modalTarget = trigger.getAttribute('data-modal-target');
      const modalWrapper = document.querySelector(`.modal-wrapper[data-modal='${modalTarget}']`);
      openModal(modalWrapper);
    });
  });

  // Handle close button clicks
  document.addEventListener('click', function (event) {
    if (event.target.closest('.close-modal')) {
      event.preventDefault();
      const modalWrapper = event.target.closest('.modal-wrapper');
      closeModal(modalWrapper);
    }
  });

  // Handle overlay clicks
  document.addEventListener('click', function (event) {
    if (
      event.target.classList.contains('modal-overlay') &&
      event.target.classList.contains('modal-open')
    ) {
      const modalWrapper = event.target.closest('.modal-wrapper');
      closeModal(modalWrapper);
    }
  });

  // ESC key closes any open modal
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.modal-wrapper').forEach(modalWrapper => {
        closeModal(modalWrapper);
      });
    }
  });
});